/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import typography from "assets/theme/theme-dark/base/typography";
import colors from "assets/theme/theme-dark/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography;
const { text, transparent } = colors;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: {
      minWidth: pxToRem(160),
      padding: `${pxToRem(16)} ${pxToRem(8)}`,
      fontSize: size.sm,
      color: text.main,
      textAlign: "left",
      backgroundColor: `${transparent.main} !important`,
    },
  },
};

export default menu;
